import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EraseStylesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EraseStyles",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.49 27.01H17.48l11.47-11.77a3.577 3.577 0 0 0 0-5.06l-7.12-7.11c-.65-.64-1.54-1.04-2.52-1.04s-1.88.4-2.52 1.04L3.05 16.43a3.577 3.577 0 0 0 0 5.06l7.42 7.42c.52.52 1.19.87 1.94.99h.02q.18.06.39.06h15.67c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5V27ZM18.9 5.19c.11-.11.25-.17.41-.17s.31.07.41.17l7.11 7.11c.11.11.17.26.17.42s-.07.31-.17.42l-6.24 6.36-8.12-8.05z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M26 27.01H13.27c-.55 0-1-.45-1-1s.45-1 1-1H26c.55 0 1 .45 1 1s-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.35 27.01c-.8 0-1.55-.31-2.12-.88l-5.35-5.35c-.57-.57-.88-1.32-.88-2.12s.31-1.55.88-2.12L16.54 5.88a3 3 0 0 1 4.24 0l5.35 5.35c.57.57.88 1.32.88 2.12s-.31 1.56-.88 2.12L15.47 26.13c-.57.57-1.32.88-2.12.88M18.66 7c-.26 0-.51.1-.71.29L7.29 17.95c-.19.19-.29.44-.29.71s.1.52.29.71l5.35 5.36c.38.38 1.04.38 1.41 0l10.66-10.66c.39-.39.39-1.02 0-1.42L19.36 7.3a.97.97 0 0 0-.71-.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.1 21.1c-.26 0-.51-.1-.71-.29l-8.18-8.18a.996.996 0 1 1 1.41-1.41l8.18 8.18a.996.996 0 0 1-.71 1.7Z"
      })]
    })
  }));
};